// DXP Hub API paths (shared by hub React Query modules).

// DXP Hub role → permissions (placeholder path until backend implements it)
export const FETCH_HUB_ROLE_PERMISSIONS = "/dxphub/permissions/roles";

// DXP Hub Solutions (sub-applications under a company app-map)
export const FETCH_HUB_SOLUTIONS =
  "/api/company/{companyUuid}/app-map/{appMapId}/sub-applications";

// DXP Hub Catalog Types
export const CATALOG_TYPES_BASE = "/dxphub/catalogTypes";
export const FETCH_CATALOG_TYPES = CATALOG_TYPES_BASE;
export const FETCH_CATALOG_TYPE_BY_ID = `${CATALOG_TYPES_BASE}/:typeId`;
export const CREATE_CATALOG_TYPE = CATALOG_TYPES_BASE;
export const UPDATE_CATALOG_TYPE = `${CATALOG_TYPES_BASE}/:typeId`;
export const DELETE_CATALOG_TYPE = `${CATALOG_TYPES_BASE}/:typeId`;
export const SEARCH_CATALOG_TYPES = `${CATALOG_TYPES_BASE}/search`;

// DXP Hub Catalogs
export const HUB_CATALOGS_BASE = "/dxphub/catalogs";
export const FETCH_HUB_CATALOGS = HUB_CATALOGS_BASE;
export const FETCH_HUB_CATALOG_BY_ID = `${HUB_CATALOGS_BASE}/:catalogId`;
export const FETCH_HUB_CATALOG_BY_ID_AND_VERSION = `${HUB_CATALOGS_BASE}/:catalogId/:version`;
export const CREATE_HUB_CATALOG = HUB_CATALOGS_BASE;
export const UPDATE_HUB_CATALOG = HUB_CATALOGS_BASE;
export const DELETE_HUB_CATALOG = `${HUB_CATALOGS_BASE}/:catalogId/:versionId`;
export const FETCH_HUB_CATALOGS_BY_TYPE = `${HUB_CATALOGS_BASE}/type/:typeId`;
export const FETCH_HUB_CATALOG_ADDONS = `${HUB_CATALOGS_BASE}/:catalogId/addons`;
export const SEARCH_HUB_CATALOGS = `${HUB_CATALOGS_BASE}/search`;

// DXP Hub Ratings
export const RATINGS_BASE = "/dxphub/ratings";
export const FETCH_RATINGS = RATINGS_BASE;
export const SEARCH_RATINGS = `${RATINGS_BASE}/search`;
export const FETCH_RATING_BY_ID = `${RATINGS_BASE}/:ratingId`;
export const CREATE_RATING = RATINGS_BASE;
export const UPDATE_RATING = `${RATINGS_BASE}/:ratingId`;
export const DELETE_RATING = `${RATINGS_BASE}/:ratingId`;
export const FETCH_RATINGS_BY_CATALOG = `${RATINGS_BASE}/catalog/:catalogId`;
export const FETCH_RATING_AVERAGE_BY_CATALOG = `${RATINGS_BASE}/catalog/:catalogId/average`;

// DXP Hub Reviews (PRB Reviews)
export const PRB_REVIEWS_BASE = "/dxphub/prbReviews";
export const FETCH_PRB_REVIEWS = PRB_REVIEWS_BASE;
export const FETCH_PRB_REVIEW_BY_ID = `${PRB_REVIEWS_BASE}/:reviewId`;
export const CREATE_PRB_REVIEW = PRB_REVIEWS_BASE;
export const DELETE_PRB_REVIEW = `${PRB_REVIEWS_BASE}/:reviewId`;
export const FETCH_PRB_REVIEWS_BY_CATALOG = `${PRB_REVIEWS_BASE}/catalog/:catalogId`;
export const SEARCH_PRB_REVIEWS = `${PRB_REVIEWS_BASE}/search`;

// DXP Hub Packages
export const PACKAGES_BASE = "/dxphub/packages";
export const FETCH_PACKAGES = PACKAGES_BASE;
export const SEARCH_HUB_PACKAGES = `${PACKAGES_BASE}/search`;
export const FETCH_PACKAGE_BY_ID = `${PACKAGES_BASE}/:packageId`;
export const CREATE_PACKAGE = PACKAGES_BASE;
export const UPDATE_PACKAGE = PACKAGES_BASE;
export const DELETE_PACKAGE = `${PACKAGES_BASE}/:packageId`;

// DXP Hub CDVs (Configuration Data Values)
export const CDVS_BASE = "/dxphub/cdvs";
export const FETCH_CDVS = CDVS_BASE;
export const FETCH_CDV_BY_ID = `${CDVS_BASE}/:cdvId`;
export const CREATE_CDV = CDVS_BASE;
export const UPDATE_CDV = `${CDVS_BASE}/:cdvId`;
export const DELETE_CDV = `${CDVS_BASE}/:cdvId`;
export const SEARCH_CDVS = `${CDVS_BASE}/search`;

// DXP Hub Comments
export const COMMENTS_BASE = "/dxphub/comments";
export const FETCH_COMMENTS = COMMENTS_BASE;
export const FETCH_COMMENT_BY_ID = `${COMMENTS_BASE}/:commentId`;
export const CREATE_COMMENT = COMMENTS_BASE;
export const UPDATE_COMMENT = `${COMMENTS_BASE}/:commentId`;
export const DELETE_COMMENT = `${COMMENTS_BASE}/:commentId`;
export const FETCH_COMMENTS_BY_CATALOG = `${COMMENTS_BASE}/catalog/:catalogId`;
export const SEARCH_COMMENTS = `${COMMENTS_BASE}/search`;

// DXP Hub Data Sources
export const DATASOURCES_BASE = "/dxphub/datasources";
export const FETCH_DATASOURCES = DATASOURCES_BASE;
export const FETCH_DATASOURCE_BY_ID = `${DATASOURCES_BASE}/:datasourceId`;
export const CREATE_DATASOURCE = DATASOURCES_BASE;
export const UPDATE_DATASOURCE = `${DATASOURCES_BASE}/:datasourceId`;
export const DELETE_DATASOURCE = `${DATASOURCES_BASE}/:datasourceId`;

// DXP Hub Package Catalog Relations
export const PACKAGE_CATALOG_RELATIONS_BASE = "/dxphub/packageCatalogRelations";
export const CREATE_PACKAGE_CATALOG_RELATION = PACKAGE_CATALOG_RELATIONS_BASE;
export const FETCH_PACKAGE_CATALOG_RELATIONS_BY_PACKAGE = `${PACKAGE_CATALOG_RELATIONS_BASE}/package/:packageId`;
export const DELETE_PACKAGE_CATALOG_RELATION = `${PACKAGE_CATALOG_RELATIONS_BASE}/package/:packageId/catalog/:catalogId`;

// DXP Hub Carts
export const CARTS_BASE = "/dxphub/carts";
export const FETCH_HUB_CARTS = CARTS_BASE;
export const SEARCH_HUB_CARTS = `${CARTS_BASE}/search`;
export const FETCH_HUB_CART_BY_ID = `${CARTS_BASE}/:cartId`;
export const CREATE_HUB_CART = CARTS_BASE;
export const UPDATE_HUB_CART = `${CARTS_BASE}/:cartId`;
export const DELETE_HUB_CART = `${CARTS_BASE}/:cartId`;
export const FETCH_HUB_CARTS_BY_USER = `${CARTS_BASE}/user/:userId`;

// DXP Hub Package Deployments
export const PACKAGE_DEPLOYMENTS_BASE = "/dxphub/packageDeployments";
export const FETCH_PACKAGE_DEPLOYMENTS = PACKAGE_DEPLOYMENTS_BASE;
export const FETCH_PACKAGE_DEPLOYMENT_BY_ID = `${PACKAGE_DEPLOYMENTS_BASE}/:deploymentId`;
export const CREATE_PACKAGE_DEPLOYMENT = PACKAGE_DEPLOYMENTS_BASE;
export const UPDATE_PACKAGE_DEPLOYMENT = `${PACKAGE_DEPLOYMENTS_BASE}/:deploymentId`;
export const DELETE_PACKAGE_DEPLOYMENT = `${PACKAGE_DEPLOYMENTS_BASE}/:deploymentId`;
export const FETCH_PACKAGE_DEPLOYMENT_SUBSCRIPTIONS = `${PACKAGE_DEPLOYMENTS_BASE}/subscriptions`;
export const SEARCH_PACKAGE_DEPLOYMENTS = `${PACKAGE_DEPLOYMENTS_BASE}/search`;

// Auth
export const LOGOUT = "/auth/logout";

// User Profile
export const GET_USER_INFO = "/api/user-info";
export const GET_USER_PERMISSIONS = "/api/hub/users/permissions";
export const GET_COMPANY = "/api/company";
export const GET_COMPANIES = "/api/companies";

// Regional data
export const GET_LANGUAGES = "/api/data/languages";
export const GET_TIMEZONES = "/api/data/timezones";
export const GET_COUNTRIES = "/api/data/countries";

// Export
export const EXPORT_BASE = "/dxphub/export";
export const EXPORTS_BASE = "/dxphub/exports";
export const FETCH_EXPORTS = EXPORTS_BASE;
export const GENERATE_EXPORT_TOKEN = `${EXPORTS_BASE}/:exportId/generateToken`;
export const IMPORT_BASE = "/dxphub/import";
